export const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#212529",
      borderColor: state.isFocused ? "#f8f9fa" : "#495057",
      color: "#f8f9fa",
      borderColor: "#f8f9fa",
      "&:hover": {
        borderColor: "#f8f9fa",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#212529",
      color: "#f8f9fa",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#495057" : "#212529",
      color: state.isSelected ? "#f8f9fa" : "#ced4da",
      "&:hover": {
        backgroundColor: "#343a40",
        color: "#ffffff",
      },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#495057",
      color: "#f8f9fa",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#f8f9fa",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#f8f9fa",
      "&:hover": {
        backgroundColor: "#dc3545",
        color: "#ffffff",
      },
    }),
  };